/**
 * Scene viewer config.
 */
export type SceneViewerConfig = {
  frustumCulling: boolean;
  // hideAvatar: boolean;
  // hideBackground: boolean;
  // hideGarmentHems: boolean;
  // hideGarmentPieces: boolean;
  // hideGarmentSeams: boolean;
  // hideGround: boolean;
  // hideLogos: boolean;
  hideStitches: boolean;
  // useGarmentGeometry: boolean;
  // useOrderIndependentTransparency: boolean;
  useStitchesDecals: boolean;
};

/**
 * Create scene viewer config.
 * @param config - Configuration options.
 */
export const create = (() => {
  const ConfigDef: SceneViewerConfig = {
    frustumCulling: true,
    // hideAvatar: true,
    // hideBackground: true,
    // hideGarmentHems: false,
    // hideGarmentPieces: false,
    // hideGarmentSeams: false,
    // hideGround: true,
    // hideLogos: false,
    hideStitches: false,
    // useGarmentGeometry: true,
    // useOrderIndependentTransparency: false,
    useStitchesDecals: true,
  };

  return (config?: Partial<SceneViewerConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
